let initialized = false;

function getDrawer(drawerId) {
    return document.getElementById(drawerId);
}

function openDrawer(drawerId) {
    const drawer = getDrawer(drawerId);

    if (!drawer) {
        return false;
    }

    document.body.classList.add('drawer_is_opened');
    drawer.setAttribute('open', '');

    return true;
}

function closeDrawer(drawerId) {
    const drawer = getDrawer(drawerId);

    if (!drawer) {
        return false;
    }

    drawer.removeAttribute('open');

    if (!document.querySelector('.drawer[open]')) {
        document.body.classList.remove('drawer_is_opened');
        document.body.classList.remove('cart-drawer-open');
    }

    return true;
}

function toggleDrawer(drawerId) {
    const drawer = getDrawer(drawerId);

    if (!drawer) {
        return false;
    }

    if (drawer.hasAttribute('open')) {
        return closeDrawer(drawerId);
    }

    return openDrawer(drawerId);
}

export function initDrawer() {
    if (initialized) {
        return;
    }

    initialized = true;

    window.IrrobaDrawer = {
        open: openDrawer,
        close: closeDrawer,
        toggle: toggleDrawer
    };

    $(document)
        .off('click.irrobaDrawer', '[data-drawer-open]')
        .on('click.irrobaDrawer', '[data-drawer-open]', function() {
            openDrawer($(this).data('target'));
        })
        .off('click.irrobaDrawer', '[data-drawer-close]')
        .on('click.irrobaDrawer', '[data-drawer-close]', function() {
            closeDrawer($(this).data('target'));
        })
        .off('click.irrobaDrawer', '[data-drawer-toggle]')
        .on('click.irrobaDrawer', '[data-drawer-toggle]', function() {
            toggleDrawer($(this).data('target'));
        });
}
